<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('checkStatus')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('checkPending')" value="0"></el-option>
            <el-option :label="$t('getApproved')" value="1"></el-option>
            <el-option :label="$t('notApproved')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row class="table-btns">
        <el-button
          type="text"
          v-if="
            loginInfo.orgType == 1 ||
              loginInfo.orgType == 2 ||
              loginInfo.orgType == 3
          "
          size="mini"
          icon="el-icon-edit"
          @click="openAddApply('virtualAccountRecharge')"
          >{{ $t("virtualAccountRecharge") }}</el-button
        >
      </el-row>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="type"
          fixed="left"
          :label="$t('applicationType')"
          width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0" class="text-primary">{{
              $t("transferRechargeApply")
            }}</span>
            <span v-if="scope.row.type == 1" class="text-success">{{
              $t("cashRechargeApply")
            }}</span>
            <span v-if="scope.row.type == 2" class="text-danger">{{
              $t("withdrawDepositApply")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applyAmount"
          fixed="left"
          :label="$t('applyAmount')"
          width="160"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span
            >{{ scope.row.applyAmount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          fixed="left"
          :label="$t('checkStatus')"
          width="130"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applyCode"
          :label="$t('applyCode')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="applyRemark"
          :label="$t('applayRemark')"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="applyTime"
          :label="$t('applyTime')"
          width="220"
        ></el-table-column>
        <el-table-column
          prop="applyUser"
          :label="$t('applyUser')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="bankName"
          :label="$t('bankName')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="bankTransferserial"
          :label="$t('bankTransferserial')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="transfeDate"
          :label="$t('transfeDate')"
          width="220"
        ></el-table-column>
        <el-table-column
          prop="orgInfoId"
          :label="$t('orgId')"
          width="160"
        ></el-table-column>

        <el-table-column
          prop="transactionCode"
          :label="$t('transactionId')"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="transactionInfoId"
          :label="$t('transactionInfoId')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          width="220"
        ></el-table-column>
        <el-table-column
          prop="verifyUser"
          :label="$t('auditor')"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="verifyRemark"
          :label="$t('checkRemark')"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isAddApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-form-item
          :label="$t('destinationType')"
          prop="destinationType"
          v-if="loginInfo.orgType === 1"
        >
          <el-radio-group v-model="applyForm.destinationType">
            <el-radio :label="2">{{ $t("operateOrg") }}</el-radio>
            <el-radio :label="3">{{ $t("franchiseStore") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('Payee org')"
          prop="orgInfoId"
          v-if="applyForm.destinationType === 2"
        >
          <el-select v-model="applyForm.orgInfoId" filterable>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$t('franchiseStore')"
          prop="orgInfoId"
          v-if="applyForm.destinationType === 3"
        >
          <el-select v-model="applyForm.orgInfoId" filterable>
            <el-option
              v-for="(t, i) in franchisedList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- org Type == 2 -->
        <el-form-item
          :label="$t('selectAssistant')"
          prop="userId"
          v-if="loginInfo.orgType == 2"
        >
          <el-select v-model="applyForm.userId" filterable>
            <el-option
              v-for="(t, i) in myOrgUserList"
              :key="i"
              :label="t.loginName + ' -- ' + t.name + '  ' + t.surname"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- org type == 3 -->
        <el-form-item
          :label="$t('selectAssistant')"
          prop="userId"
          v-if="loginInfo.orgType == 3"
        >
          <el-select v-model="applyForm.userId" filterable>
            <el-option
              v-for="(t, i) in myOrgUserList"
              :key="i"
              :label="t.loginName + ' -- ' + t.name + '  ' + t.surname"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- fields -->
        <el-form-item :label="$t('rechargeAmount')" prop="applyAmount">
          <el-input size="medium" v-model="applyForm.applyAmount"></el-input>
        </el-form-item>

        <el-form-item :label="$t('applayRemark')" prop="remark">
          <el-input
            type="textarea"
            size="medium"
            v-model="applyForm.remark"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitAdd('applyForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import orgInfoApply from "@/api/orgInfoApply";

import org from "@/api/org";

export default {
  name: "virtualAccountRecharge",
  data() {
    return {
      isLoading: false,
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      orgList: [],

      franchisedList: [],
      myOrgUserList: [],

      queryForm: {},
      //是否显示新增申请弹框
      isAddApply: false,
      //申请弹框标题
      applyTitle: "",
      //申请表单
      applyForm: {
        destinationType: null,
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    rules() {
      return {
        destinationType: [
          {
            required: true,
            message: this.$t("pleaseSelectDestination"),
            trigger: "change",
          },
        ],

        orgInfoId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],

        userId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        applyAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    getList() {
      let _this = this;
      _this.isLoading = true;

      orgInfoApply.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        },
      });
    },

    getOrgList() {
      let _this = this;
      org.getOrgListOnly({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) {
            _this.orgList = res.data.records;
          } else {
            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },

    getFranchisedList() {
      let _this = this;
      org.getFranchisedList({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) {
            _this.franchisedList = res.data.records;
          } else {
            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },

    getMyOrgUserList() {
      let _this = this;
      org.getMyOrgUserList({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) {
            _this.myOrgUserList = res.data.records;
          } else {
            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },

    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    openAddApply(title) {
      this.isAddApply = true;
      this.applyTitle = title;
      this.applyForm.type = 1;
    },

    /**提交充值申请 */
    onSubmitAdd(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;

        _this[refName].businessCode = 10;
        orgInfoApply.addVirtualAccountRecharge({
          param: _this[refName],
          success: (res) => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));

              _this.applyForm = {
                orgInfoId: null,
                applyAmount: null,
                userId: null,
                remark: "",
              };
              _this.isAddApply = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          },
        });
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
    this.getOrgList();
    this.getFranchisedList();
    this.getMyOrgUserList();
  },
};
</script>

<style lang="less" scoped>
.recharge-apply {
  #org-info-from {
    .el-col-8 {
      margin-bottom: 31px;
    }
  }

  .testes {
    animation: identifier 300ms;
  }
  @keyframes identifier {
    0% {
      height: 0px;
    }
    100% {
      height: 100px;
    }
  }
}
</style>
